<template>
  <div
    class="pageSmallCard listItem"
    :class="{
      isUsed: itemData.couponsStatus == 4,
    }"
  >
    <div @click="handleSelect">
      <div class="pageFlexBetween title">
        <p>
          {{ itemData.couponsProductName }}
        </p>
        <span class="pageFontWeight" v-if="itemData.couponsType === 0"
          ><i class="iconfont iconu728" />{{
            $formatMoney(itemData.couponsDeno, 1)
          }}</span
        >
      </div>
      <div class="line"></div>
      <div class="detail">
        <div class="pageFlexColumn icons">
          <div class="pageBgBlock">
            <i class="iconfont icon-liquan"></i>
          </div>
          <p :class="'pageDefaultRadius'">
            <!-- {{ itemData.orderStatusText }} -->
            已使用
          </p>
        </div>
        <div v-if="show" class="list">
          <li>卡号：{{ itemData.couponsNum }}</li>
          <!-- <li v-if="itemData.orderAccount">充值帐号：{{ itemData.orderAccount }}</li> -->
          <li>激活时间：{{ itemData.couponsActivateTime }}</li>
          <li>使用时间：{{ itemData.couponsUsedTime }}</li>
          <a
            v-if="itemData.couponsType === 0"
            @click="showRecovery(itemData.couponsId)"
            >查看已转让卡券</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { getRecoveryHomeUrl } from "api/onLine";

export default {
  props: {
    itemData: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      html: "",
      orderStatus: "",
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleLaunchFn(e) {
      console.log(e);
    },
    handleErrorFn(e) {
      console.log("fail", e.detail);
    },
    getIcon(type) {
      let arry = { icon: "", color: "" };
      switch (type) {
        //退款、余额充值、线下服务
        case 1:
        case 3:
          arry.icon = "icondingdan1";
          break;
        //油卡、加油广东
        case 4:
        case 13:
          arry.icon = "iconjiayouqia";
          break;
        //话费流量
        case 5:
        case 6:
          arry.icon = "iconu1053";
          break;
        //购物卡
        case 7:
          arry.icon = "iconqiapian";
          break;
        //视频、音乐、游戏充值
        case 8:
          arry.icon = "iconziyuan1";
          break;
        case 9:
          arry.icon = "iconu1081";
          break;
        case 10:
          arry.icon = "iconyouxi";
          break;
        //卡券购买
        case 2:
        case 11:
          arry.icon = "iconquan";
          break;
        //转让订单
        case 12:
          arry.icon = "iconzhuanrangzhuangtai";
          break;
        //健康档案、家医保、健康体检
        case 14:
          arry.icon = "iconjiankangdangan";
          break;
        case 15:
          arry.icon = "iconhuiyuan";
          break;
        //加油兑换券
        case 16:
          arry.icon = "iconjixuduihuan";
          break;
        case 17:
          arry.icon = "iconnianshendaoqitixing";
          break;
        case 18:
          arry.icon = "icondrive";
          break;
      }
      return arry;
    },
    handleClick() {
      var clipboard = new Clipboard(".copy");
      clipboard.on("success", () => {
        this.$success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", () => {
        // 不支持复制
        console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    handleSelect() {
      this.$emit("click");
    },
    showRecovery(val) {
      getRecoveryHomeUrl(val).then((res) => {
        if (res.status == 200) {
          if ((res.data != "") & (res.data != null)) {
            location.href = res.data;
          }
        } else {
          this.$error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@themeColor: #fff;
.listItem {
  width: 100%;
  padding: 0;
  margin-top: 15px;
  min-height: 90px;
  font-size: var(--pFont);
  .goUrl {
    .van-divider {
      margin: 0px;
    }
    .van-cell__title,
    .van-cell__value {
      flex: initial;
    }
    .url {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 5px;
      .van-cell__title {
        width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .title {
    // height: 40px;
    padding: 10px 0;
    font-size: var(--titleFont);
    color: var(--titleColor);
    p {
      margin-left: 24%;
    }
    span {
      color: var(--redColor);
      margin-right: 13px;
      max-width: 60px;
      min-width: 50px;
      text-align: right;
    }
  }
  .line {
    height: 5px;
    margin: 0 2px;
    margin-top: -5px;
    box-shadow: 0px 4px 4px 2px #f4f4f4;
  }
  .unPay {
    p {
      color: var(--greenColor);
      background: #eef6e0;
    }
  }
  .processing {
    p {
      background: #fdecd5;
      color: var(--depYelColor);
    }
  }
  .detail {
    padding: 12px 0;
    display: flex;
    .icons {
      width: 19%;
      color: #666;
      margin: 0 10px;
      display: inline-flex;
      vertical-align: top;
      margin-top: -40px;
      .pageBgBlock {
        color: #fff;
        width: 50px;
        height: 50px;
        background: var(--redColor);
        margin-bottom: 4px;
        .iconfont {
          font-size: 28px;
          margin: 4px 10px;
        }
      }
      p {
        margin-top: 5px;
        padding: 5px 8px;
        font-size: var(--spanFont);
        color: var(--depBlueColor);
        background: #e0f4fd;
      }
      .pay {
        background: #eef6e0;
        color: #70b603;
      }
      .handle {
        background: #fdecd5;
        color: #ff3300;
      }
      .cancel {
        background: #fefefe;
        color: #000;
      }
    }
    .details {
      width: 73%;
      display: inline-block;
      line-height: 1.5;
      padding-bottom: 15px;
      li {
        font-size: var(--smallFont);
        color: #555555;
        word-break: break-all;
      }
    }
    .list {
      width: 66%;
      font-size: var(--smallFont);
      color: var(--hidColor) !important;
      display: inline-block;
      line-height: 1.8;
      li {
        word-break: break-all;
      }
      a {
        color: #d9001b;
        font-size: 14px;
        font-weight: bold;
      }
    }
    .remark {
      margin-top: 5px;
      padding-top: 4px;
      font-size: var(--pFont);
      border-top: 1px solid var(--lineColor);
      color: var(--hidColor);
    }
    h5 {
      margin-top: 6px;
      color: var(--depBlueColor);
    }
  }
  .btnGroud {
    .pageSmallBtns {
      width: 50%;
      height: 40px;
      border-radius: 0px;
    }
    .btnBig {
      width: 100% !important;
    }
    .cancel {
      color: var(--depHidColor) !important;
    }
  }
  .footer {
    color: #fff;
    background: var(--depBlueColor);
    height: 35px;
    padding: 0 15px;
    box-sizing: border-box;
    p {
      flex: 1;
    }
    .pageSmallBtns {
      color: var(--depBlueColor) !important;
      border-radius: 5px;
      font-size: var(--spanFont);
      height: 24px;
    }
  }
}
.isUsed {
  background: var(--bgColor);
  position: relative;
  border: 1px solid #fff;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 125px;
    background: rgba(249, 249, 249, 0.5);
  }
}
</style>
